import React from 'react'

const ParallaxPanel = ({imageToPx}) => {
  return (
    <div className="min-h-screen w-full parallax" style={{backgroundImage:`url(${imageToPx})`}}>
    </div>
  )
}

export default ParallaxPanel